<template>
  <div class="main pb-x8">
    <Nav :authRequired = "true"/>
    <div class="container">
      <div class="row mb-x2">
        <div class="col">
          <!-- this needs to be set to a function that checks for going back -->
          <!-- profile edit goes back to profile -->
          <!-- create goes back to /users -->
          <!-- edit user goes back to user details -->
          <!-- the bottom two apply to events and days etc too -->
          <button @click="goBack" class="zero-btn zero-btn-standard zero-btn-primary zero-btn-outline slim mb-x2">
            <i class="fas fa-chevron-left mr-x1"></i> BACK
          </button>
          <h2 v-if="!editMode">Create a User</h2>
          <h2 v-else>
            <span v-if="profileMode">Edit Profile</span>
            <span v-else>Edit User</span>
          </h2>
        </div>
      </div>
      <div class="row mb-x4">
        <div class="col-sm-10 col-md-8 col-lg-6 zero-form">
          <div class="input-block mb-x2">
            <label for="user-name">
              Name
            </label>
            <input
              type="text"
              id="user-name"
              name="user-name"
              placeholder=""
              class="standard-text-input"
              v-model="oneUser.name"
              :class="{ 'has-error': errors.name }"
              autocomplete="off"
            >
            <p class="input-error" v-if="errors.name">
              Please enter a name
            </p>
          </div>
          <div class="input-block mb-x2">
            <label for="entry-email">
              email
            </label>
            <input
              type="text"
              id="entry-email"
              name="entry-email"
              placeholder=""
              class="standard-text-input"
              v-model="oneUser.email"
              :class="{ 'has-error': errors.email }"
              autocomplete="off"
            >
            <p class="input-error" v-if="errors.email">
              Please enter an email address
            </p>
          </div>
          <div class="input-block mb-x2">
            <label for="user-email">
              <span v-if="editMode">update </span>password
            </label>
            <input
              type="password"
              id="user-password"
              name="user-password"
              placeholder=""
              class="standard-text-input"
              v-model="oneUser.password"
              :class="{ 'has-error': errors.password }"
              autocomplete="off"
              @keyup.enter="login()"
            >
            <div class="input-prefix clickable" @click="togglePW()">
              <i class="fas fa-eye" v-if="hidePW"></i>
              <i class="fas fa-eye-slash" v-else></i>
            </div>
            <p class="input-error" v-if="errors.password">
              Please enter a password
            </p>
          </div>
          <div class="input-block mb-x2">
            <label for="entry-permissions">
              permissions
            </label>
            <div class="checkbox-block">
              <input type="checkbox" id="perm1" name="perm1" v-model="permissionsObj.admin" />
              <label for="scales">user admin</label>
            </div>
            <div class="checkbox-block">
              <input type="checkbox" id="perm2" name="perm2" v-model="permissionsObj.editor" />
              <label for="scales">editor</label>
            </div>
            <div class="checkbox-block">
              <input type="checkbox" id="perm3" name="perm3" v-model="permissionsObj.viewer" />
              <label for="scales">viewer</label>
            </div>
          </div>
          <div class="label-value-unit">
            <div class="micro-label">profile photo</div>
            <div class="value" v-if="oneUser.userimage">
              <img class="user-image" :src="filePath + 'uploads/profiles/' + oneUser.userimage" >
            </div>
            <div v-else class="value">
              no image uploaded
            </div>
          </div>
          <div class="input-block mb-x2">
            <label for="image-input">
              <div class="label-inner">upload new profile picture</div>
              <div class="file-drag-drop" @dragover="fileDragOver" @dragleave="fileDragLeave" @drop="fileDrop">
                Drag a single file for upload
              </div>
            </label>
            <input
              type="file"
              id="image-input"
              name="image-input"
              placeholder=""
              class="standard-text-input mb-x2"
              autocomplete="off"
              ref="fileinput"
              @change="fileInputChange"
              accept=".pdf,.jpg,.jpeg,.png,.csv"
            >
          </div>
          <div class="zero-btn zero-btn-standard zero-btn-primary" @click="postUser()" v-if="!editMode">
            Create User
          </div>
          <div class="zero-btn zero-btn-standard zero-btn-primary" @click="putUser()" v-else>
            Update <span v-if="profileMode">Profile</span><span v-else>User</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import Nav from '@/components/Nav.vue'

Vue.use(VueCookies)
// import shared from '@/shared.js'
// example usage: shared.parseDate('2012-08-11')
const axios = require('axios')

// endpoints
const apiChoice = process.env.VUE_APP_API_URL

export default {
  name: 'home',
  components: {
    Nav
  },
  data () {
    return {
      isLoading: false,
      userToken: '',
      isLoggedIn: false,
      userData: {
        'id': '',
        'name': '',
        'email': ''
      },
      oneUserId: '',
      oneUser: {
        'name': '',
        'email': '',
        'password': ''
      },
      errors: {
        'name': false,
        'email': false,
        'password': false
      },
      editMode: false,
      inputFile: '',
      profileMode: false,
      permissionsObj: {
        admin: false,
        editor: false,
        viewer: false
      },
      hidePW: true,
      filePath: apiChoice
    }
  },
  created () {
    if (this.$cookies.isKey('u')) {
      this.isLoggedIn = true
      this.userData = this.$cookies.get('u')
      this.userToken = this.$cookies.get('j') + '.' + this.$cookies.get('w') + '.' + this.$cookies.get('t')
    }
    if (this.$route.params.userid) {
      this.oneUserId = this.$route.params.userid
      this.editMode = true
      this.getOneUser()
    }
    if (this.$route.path === '/profile/edit') {
      this.profileMode = true
      this.editMode = true
      this.oneUserId = this.userData.id
      this.getOneUser()
    }
  },
  methods: {
    getOneUser () {
      axios
        .get(apiChoice + 'api/users/' + this.oneUserId, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          this.oneUser = response.data
          // parse permissions
          // move explodedPerms OUT and set it to 0000 if missing on oneUser
          // also set if it has them and is greater greater than 3 items
          let explodedPerms
          if (this.oneUser.permissions && this.oneUser.permissions.length > 3) {
            explodedPerms = [...this.oneUser.permissions]
          } else {
            explodedPerms = '0000'
          }
          // hardcoding number of permissions to force empty or bad permission values to zero out
          this.permissionsObj.admin = explodedPerms[0] === '1'
          this.permissionsObj.editor = explodedPerms[1] === '1'
          this.permissionsObj.viewer = explodedPerms[2] === '1'
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
    },
    postUser () {
      if (!this.oneUser.name || !this.oneUser.email || !this.oneUser.password) {
        this.errors.name = !this.oneUser.name
        this.errors.email = !this.oneUser.email
        this.errors.password = !this.oneUser.password
        window.scrollTo({ top: 0, behavior: 'smooth' })
        return
      }
      let formData = new FormData()
      if (document.getElementById('image-input').value !== '') {
        // let imagefile = document.querySelector('#image-input')
        // formData.append('example_file', imagefile.files[0])
        formData.append('userimage', document.getElementById('image-input').files[0])
      } else {
        formData.append('userimage', null)
      }
      // load up form data
      formData.append('permissions', this.permissionsToString())
      formData.append('email', this.oneUser.email)
      formData.append('name', this.oneUser.name)
      formData.append('password', this.oneUser.password)
      axios
        .post(apiChoice + 'auth/registration', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          // do something with response.data.data
          console.log(response)
          this.$router.push({ path: '/users' })
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          // this.isLoading = false
        })
    },
    putUser () {
      let formData = new FormData()
      if (document.getElementById('image-input').value !== '') {
        formData.append('userimage', document.getElementById('image-input').files[0])
      }
      // load up form data
      formData.append('permissions', this.permissionsToString())
      formData.append('email', this.oneUser.email)
      formData.append('name', this.oneUser.name)
      if (this.oneUser.password) {
        formData.append('password', this.oneUser.password)
      }
      // adding this to make it a put
      formData.append('_method', 'PUT')
      // set as post to get around formdata + put not working together
      axios
        .post(apiChoice + 'api/users/' + this.oneUserId, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + this.userToken
          }
        })
        .then((response) => {
          // do something with response.data.data
          if (this.profileMode) {
            let userJson = JSON.stringify(response.data)
            this.$cookies.set('u', userJson, '5d', null, null, true, 'Lax')
            this.$router.push({ path: '/profile' })
          } else {
            this.$router.push({ path: '/users/' + this.oneUserId })
          }
          // stop loading
          // this.isLoading = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          // this.isLoading = false
        })
    },
    fileInputChange () {
      // I think for single file upload this isn't necessary...
      this.inputFile = this.$refs.fileinput.files
    },
    fileDragOver (event) {
      event.preventDefault()
      // Add some visual fluff to show the user can drop its files
      if (!event.currentTarget.classList.contains('drag-on-active')) {
        event.currentTarget.classList.add('drag-on-active')
      }
    },
    fileDragLeave (event) {
      // Clean up
      event.currentTarget.classList.remove('drag-on-active')
    },
    fileDrop (event) {
      event.preventDefault()
      this.$refs.fileinput.files = event.dataTransfer.files
      this.fileInputChange() // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.remove('drag-on-active')
    },
    permissionsToString () {
      let permissionsString = ''
      permissionsString += this.permissionsObj.admin ? 1 : 0
      permissionsString += this.permissionsObj.editor ? 1 : 0
      permissionsString += this.permissionsObj.viewer ? 1 : 0
      // this should always be zero
      permissionsString += 0
      return permissionsString
    },
    togglePW () {
      if (this.hidePW) {
        document.getElementById('user-password').type = 'text'
        this.hidePW = false
      } else {
        document.getElementById('user-password').type = 'password'
        this.hidePW = true
      }
    },
    goBack () {
      // if profile => back to profile
      // if user create => back to users
      // if user edit => back to users dets
      if (this.profileMode) {
        this.$router.push({ path: '/profile' })
      } else if (this.editMode) {
        this.$router.push({ path: '/users/' + this.oneUserId })
      } else {
        this.$router.push({ path: '/users' })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.tab-content .menu-info{
  h2{
    display: block;
  }
}
.user-image{
  max-width: 200px;
}

// Media Queries
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
}
// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
}
// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
}
// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>
